import React from 'react';
import PropTypes from 'prop-types';

import { productFilterTypes } from 'types/PDPTypes';
import PDPUpholsteryFiltersUI from './PDPUpholsteryFiltersUI';

const PDPUpholsteryFilters = ({
  className,
  fabricFavInfoToShow,
  filterCounts = {},
  filtersCollectionVisible,
  hideFlyout = false,
  isClearanceFabricAvailable,
  loading = false,
  setFiltersCollectionVisible,
  variant,
}) => (
  <PDPUpholsteryFiltersUI
    className={className}
    fabricFavInfoToShow={fabricFavInfoToShow}
    filterCounts={filterCounts}
    hideFlyout={hideFlyout}
    isClearanceFabricAvailable={isClearanceFabricAvailable}
    loading={loading}
    selectedItem={filtersCollectionVisible}
    setSelectedItem={setFiltersCollectionVisible}
    variant={variant}
  />
);

PDPUpholsteryFilters.propTypes = {
  className: PropTypes.string,
  fabricFavInfoToShow: PropTypes.string,
  filterCounts: productFilterTypes,
  filtersCollectionVisible: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
  ]),
  hideFlyout: PropTypes.bool,
  isClearanceFabricAvailable: PropTypes.bool,
  loading: PropTypes.bool,
  setFiltersCollectionVisible: PropTypes.func,
  variant: PropTypes.string,
};

export default PDPUpholsteryFilters;
